import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { TextControl } from '../../../models/controls/text-control';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { OrderService } from '../../../services/order/order.service';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-text-control',
  templateUrl: './text-control.component.html',
  styleUrls: ['./text-control.component.scss'],
})
export class TextControlComponent
  extends BaseControlComponent<TextControl>
  implements OnInit {
  constructor(
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
    this.control = new TextControl('', '');
  }
}
